import { z } from 'zod';
import { coordinatesSchema, idSchema, zoneGeometrySchema } from './common';
// =============================================================================
// Zones geographiques
// -----------------------------------------------------------------------------
// L'administrateur dessine les zones sur une carte Leaflet + Geoman. Le polygone
// produit est stocke en GeoJSON et sert a resoudre l'adresse du client vers la zone
// qui la contient (RG-02), donc vers les techniciens habilites a intervenir.
// =============================================================================
export const createZoneSchema = z.object({
    name: z.string().trim().min(2, 'Nom de zone requis.').max(100),
    description: z.string().trim().max(1000).optional().nullable(),
    /** Couleur d'affichage sur la carte, format hexadecimal. */
    color: z
        .string()
        .trim()
        .regex(/^#[0-9a-fA-F]{6}$/, 'Couleur hexadecimale attendue (ex. #2563eb).')
        .default('#2563eb'),
    geometry: zoneGeometrySchema,
    isActive: z.boolean().default(true),
});
export const updateZoneSchema = createZoneSchema.partial();
export const zoneSchema = createZoneSchema.extend({
    id: idSchema,
    technicianCount: z.number().int().optional(),
    createdAt: z.string().optional(),
});
// --- Affectation des techniciens ---------------------------------------------
export const assignTechniciansSchema = z.object({
    /** Liste complete des techniciens de la zone : l'API remplace, elle n'ajoute pas. */
    technicianIds: z.array(idSchema).max(50),
});
// --- Resolution adresse -> zone ----------------------------------------------
export const resolveZoneQuerySchema = coordinatesSchema;
export const zoneResolutionSchema = z.discriminatedUnion('covered', [
    z.object({
        covered: z.literal(true),
        zone: z.object({
            id: idSchema,
            name: z.string(),
            color: z.string(),
        }),
        technicianCount: z.number().int().min(1),
    }),
    z.object({
        covered: z.literal(false),
        /** Message pret a afficher, invitant a rejoindre la liste d'attente (RG-05). */
        message: z.string(),
    }),
]);
// --- Liste d'attente (adresses hors zone, RG-05) ------------------------------
export const createWaitingListEntrySchema = z.object({
    email: z.string().trim().toLowerCase().email('Adresse e-mail invalide.'),
    firstName: z.string().trim().min(2).max(100),
    lastName: z.string().trim().min(2).max(100),
    phone: z.string().trim().max(20).optional().nullable(),
    street: z.string().trim().max(255),
    city: z.string().trim().max(100),
    postalCode: z
        .string()
        .trim()
        .regex(/^\d{5}$/),
    lat: z.number(),
    lng: z.number(),
    message: z.string().trim().max(1000).optional().nullable(),
});
//# sourceMappingURL=zones.js.map